import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('landing.page_title', 'Home') }],
  }),
});
